module.exports = require('./lib');


//////////////////
// WEBPACK FOOTER
// ./~/react-highlight/index.js
// module id = 358
// module chunks = 0